import { cn } from '@/lib/utils'

interface AssetCardSkeletonProps {
  className?: string
}

/**
 * Skeleton that matches the exact layout of AssetCard to prevent layout shift
 */
export function AssetCardSkeleton({ className }: AssetCardSkeletonProps) {
  return (
    <div className={cn("glass rounded-xl overflow-hidden", className)}>
      {/* Preview area — must match AssetPreview's exact dimensions so
          the lazy-mount swap (skeleton -> real card) doesn't shift the
          surrounding layout. */}
      <div className="h-[200px] md:h-auto md:aspect-video bg-white/[0.03] animate-pulse" />
      
      {/* Info bar - matches the px-3 py-2 and height of the real card */}
      <div className="px-3 py-2 flex items-center justify-between gap-3">
        <div className="min-w-0 flex-1">
          {/* Title skeleton */}
          <div className="h-4 w-3/4 bg-white/[0.05] rounded animate-pulse" />
          {/* Date skeleton */}
          <div className="h-3 w-1/3 bg-white/[0.03] rounded mt-1.5 animate-pulse" />
        </div>
        {/* Action buttons skeleton */}
        <div className="flex gap-1 shrink-0">
          <div className="size-8 bg-white/[0.03] rounded animate-pulse" />
          <div className="size-8 bg-white/[0.03] rounded animate-pulse" />
          <div className="size-8 bg-white/[0.03] rounded animate-pulse" />
        </div>
      </div>
    </div>
  )
}

interface AssetGridSkeletonProps {
  count?: number
}

/**
 * Grid of asset card skeletons matching the actual AssetGrid layout
 */
export function AssetGridSkeleton({ count = 6 }: AssetGridSkeletonProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <AssetCardSkeleton key={i} />
      ))}
    </div>
  )
}
